import { Choice } from '../generated/types';
import { DeepPartial } from './deep-partial';
import { getChoiceContext } from './get-choice-context';

export function getChoiceState(choice: DeepPartial<Choice>): {
  config: Record<string, string>;
  form: Record<string, string>;
  context: Record<string, string>;
} {
  const context = getChoiceContext(choice);
  const config = choice.config ?? {};
  const form: Record<string, string> = {};

  if (
    typeof choice.formInputs === 'object' &&
    Array.isArray(choice.formInputs) &&
    choice.formInputs.length > 0
  ) {
    choice.formInputs.forEach(({ key, value }) => {
      form[key] = value;
    });
  }

  return {
    config,
    form,
    context
  };
}
